import React from 'react';

import {
    Collapsible,
    CollapsibleContent,
    CollapsibleContextConsumer,
    CollapsibleHeading
} from '$partials/base';

import {
    IconAdd,
    IconMinus
} from '$partials/icons';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').FaqBlock}
 */
const Faq = ({
    sections,
    title
}) => {
    const bgColor = 'bg-surface-panel-white';

    return (
        <section className={`col-wrapper-breakout ${bgColor} rounded-lg pt-24 pb-16 flex flex-wrap`}>
            <div className='col-padding w-full sm:w-3/12 md:w-6/12'>
                <h2 className='type-style-sans-h1'>
                    {title}
                </h2>
            </div>

            <div className='col-padding w-full sm:w-9/12 md:w-6/12 mt-40 sm:mt-0'>
                {sections.map((item, idx) => {
                    return (
                        <Collapsible
                            className='w-full'
                            id={`faq-accordion-${idx}`}
                            isOpened={false}
                            key={`faq-accordion-${idx}`}>
                            <CollapsibleHeading className='cursor-pointer w-full'>
                                <CollapsibleContextConsumer>
                                    {({ isOpened }) => (
                                        <span className='flex items-center justify-between py-16 border-t border-border-default'>
                                            <span className='type-style-sans-body-med'>
                                                {item.title}
                                            </span>

                                            <span aria-hidden='true'>
                                                {isOpened ? <IconMinus /> : <IconAdd/>}
                                            </span>
                                        </span>
                                    )}
                                </CollapsibleContextConsumer>
                            </CollapsibleHeading>

                            <CollapsibleContent className='mt-10'>
                                <div
                                    className='rich-text type-style-sans-body pb-16'
                                    dangerouslySetInnerHTML={{ __html: item.text}} />
                            </CollapsibleContent>
                        </Collapsible>
                    );
                })}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Faq;
